import { useMutation, useQueryClient } from '@tanstack/react-query';

import { updatePrivateEvent, type UpdatePrivateEventInput } from '../../api/private-event-update';
import { invalidateLists, workshopKey } from '../dashboards/workshops/useWorkshop';

import { privateEventKey } from './usePrivateEvent';

export const privateEventHistoryKey = (id: string) => ['private-event-history', id] as const;

/** PATCH the event, then put the saved event in the detail cache and refresh
 *  everything that shows it: history, the lists, the calendars and the
 *  teacher schedules. */
export function useUpdatePrivateEvent(id: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (patch: UpdatePrivateEventInput) => updatePrivateEvent(id, patch),
    onSuccess: (event) => {
      qc.setQueryData(privateEventKey(id), event);
      void qc.invalidateQueries({ queryKey: privateEventHistoryKey(id) });
      void qc.invalidateQueries({ queryKey: workshopKey(id) });
      void qc.invalidateQueries({ queryKey: ['me'] });
      invalidateLists(qc);
    },
  });
}
